/**
 * @return {Element}
 */
export function dom(name, props = {}) {
  let d;

  if (typeof name === "string") {
    d = document.createElement(name);
  } else if (name instanceof Element) {
    d = name;
  }

  Object.keys(props).forEach(key => {
    if (key === "html") {
      d.innerHTML = props.html;
    } else if (key === "class") {
      d.classList.add(...(typeof props[key] === "string" ? props[key].split(" ") : props[key]).filter(e => e));
    } else if (key === "style") {
      Object.assign(d.style, props[key]);
    } else if (key === "attributes" || key === "attrs" || key === "attr") {
      Object.keys(props[key]).forEach(attr => {
        d.setAttribute(attr, props[key][attr]);
      });
    } else if (key === "events") {
      props.events.forEach(event => {
        d.addEventListener(event.type, event.listener);
      });
    } else if (key === "onclick") {
      d.addEventListener("click", props.onclick.bind(d), false);
    } else if (key === "children") {
      (Array.isArray(props.children) ? props.children : [props.children]).forEach(child => {
        if (typeof child === "string") {
          d.appendChild(document.createTextNode(child));
        } else if (child instanceof Element || child instanceof DocumentFragment || child instanceof Node) {
          d.appendChild(child);
        } else if (child == null) {// Ignore
        } else {
          console.warn("Unknown child type", child);
        }
      });
    } else {
      if (typeof props[key] === "function") {
        props[key].bind(d);
      }

      d[key] = props[key];
    }
  });
  return d;
}
export function icon(svg) {
  const div = document.createElement("div");
  div.innerHTML = svg.trim();
  return div.firstChild;
}